import {GuidelineType} from "../../definitions/types";

export class GuidelineModel {
    private readonly _id: number;
    private readonly _filename: string;
    private readonly _url: string;

    constructor(public readonly guideline: GuidelineType) {
        this._id = guideline.id;
        this._filename = guideline.filename;
        this._url = guideline.url;
    }

    /**
     * @method id
     * @description Returns the id of the guideline file.
     * @returns {number}
     */
    public get id(): number {
        return this._id;
    }

    /**
     * @method filename
     * @description Returns the filename of the guideline file.
     * @returns {string}
     */
    public get filename(): string {
        return this._filename;
    }

    /**
     * @method url
     * @description Returns the url of the guideline file on the server.
     * @returns {string}
     */
    public get url(): string {
        return this._url;
    }
}